import * as React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/dist/components/translate';
import * as texture from '../../../../images/homepage/section-texture.jpg';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import URLHelpers from '../../shared/url_helpers';

export default function HomepageValueProps() {
  const { shippingRegionCode } = useUser();

  const regionKey = (shippingRegionCode === 'GB') ? 'gb' : 'default';

  const renderValuePropSection = (num) => {
    const valuePropHeader = `discovery.homepageValueProps.${regionKey}.section${num}.title`;
    const valuePropText = `discovery.homepageValueProps.${regionKey}.section${num}.body`;

    const shouldAddLinkToSellMessage = (num === 1 && regionKey === 'default');
    const sellFormPath = URLHelpers.sellFormSearchPath({});

    return (
      <div>
        <h3>
          <Translate
            text={valuePropHeader}
          />
        </h3>
        <p>
          <Translate
            html
            text={valuePropText}
            args={shouldAddLinkToSellMessage ?
              { linkStart: `<a href='${sellFormPath}'>`, linkEnd: '</a>' }
              : undefined
            }
          />

        </p>
      </div>
    );
  };

  return (
    <section
      className="homepage-value-props"
      style={{ backgroundImage: `url("${texture}")` }}
    >
      <div className="homepage-value-props__inner">
        {renderValuePropSection(1)}
        {renderValuePropSection(2)}
        {renderValuePropSection(3)}
        {renderValuePropSection(4)}
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_value_props.tsx